exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1{height:120px;line-height:120px;text-align:center}.vc-chrome{position:absolute;top:35px;right:0;z-index:999}.current-color{display:inline-block;width:16px;height:16px;background-color:#000;cursor:pointer}.margin-top{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-4baf7df7","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/colorpicker/Colorpicker.vue
// module id = 1126
// module chunks = 0